export default __webpack_public_path__ + "locales/sk/SendInviteDialog.json?hash=56e11d87b58e1f2a6590b5c764d2eaee";